module.exports = __webpack_public_path__ + "img/404.362298e0.png";